module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("Farrar, Straus and Giroux"), _c('br'), _vm._v("18 West 18th Street, New York 10011")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("Copyright © 2009 by Stephen Amidon"), _c('br'), _vm._v("All rights reserved"), _c('br'), _vm._v("Distributed in Canada by Douglas & McIntyre Ltd."), _c('br'), _vm._v("Printed in the United States of America"), _c('br'), _vm._v("First edition, 2009")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Amidon, Stephen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Security / Stephen Amidon.— 1st ed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("    p.   cm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("ISBN-13: 978-0-374-25711-8 (hardcover : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("ISBN-10: 0-374-25711-6 (hardcover : alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("1. Spouses—Fiction. 2. New England—Fiction. 3. Domestic fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("  PS3551.M52 S43 2009")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("  813'.54—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("2008013850")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("Designed by Jonathan D. Lippincott")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('a', {
    attrs: {
      "href": "http://www.fsgbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.fsgbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("1  3  5  7  9  10  8  6  4  2")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("The author would like to express his gratitude to the"), _c('br'), _vm._v("Corporation of Yaddo for its generous support.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0